// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3ao2d","footer":"ChangeClinic_footer__133o9"};